<script setup>
import { reactive, computed, nextTick } from 'vue';
import router from '@/router';
import { formatDate } from '@/libraries/DateFunctions';
import { setNoShow, deleteAppointment } from '@/firebase_files/appointment_functions';
import ClinicDate from './ClinicDate.vue';
import { convertToStringWithCommas } from '@/libraries/HelperFunctions'


const props = defineProps(['clinic', 'date'])
const emits = defineEmits(['dateChange',]);

const state = reactive({
  appointments: props.clinic,
  date: props.date,
  dateString: computed(() => {
    return formatDate(state.date);
  }),
  renderApts: true,
})

init();
function init() {
  for (let i = 0; i < state.appointments.length; i++) {
    let apt = state.appointments[i];
    apt = Object.assign({
      // add cr number to object since firebase reads .cr
      cr: apt.cr,
      isCancelled: false,
    }, apt);
    // object.assign changes pointer, so we need to reassign
    state.appointments[i] = apt;
  }
}



async function onDateChange(date) {
  emits('dateChange', date);
}

/**
 * Opens appointment page for given appointment
 * Takes schedule ID as parameter, which corresponds 
 * to the aptID in firebase
 * @param {Appointment} apt 
 */
function openAppointment(apt) {
  router.push({ name: 'appointment', params: { id: apt.uniqueScheduleId } }) // should be aptID
}

function cancelApt(apt) {
  const response = confirm(`Are you sure you want to remove ${apt.name}'s appointment for ${apt.time}? This will remove the appointment from your schedule and delete any billing claims you have made.`);
  if (!response) return;
  else {
    deleteAppointment(apt)
    apt.isCancelled = true;
  }
  console.log(state.appointments)
  // remove from firebase here
}

async function noShow(apt) {
  setNoShow(apt);
  apt.noShow = !apt.noShow;
}

function returnAptType(appointmentType) {
  // Making first letter uppercase
  let aptType = appointmentType.charAt(0).toUpperCase() + appointmentType.slice(1)

  // Returns Out-Patient instead of Regular, and In-Patient instead of inpatient.
  switch (aptType) {
    case "Regular":
      return "Out-Patient";
    case "Inpatient":
      return "In-Patient";
    default:
      return aptType
  }
}

</script>

<template>
  <div class="wrapper-class">
    <ClinicDate :text="'Clinic for'" :initial-date="state.date" @set-date="(d) => onDateChange(d)" />

    <div class="content-box">
      <div class="table-header">
        <div class="text-column">Time</div>
        <div class="text-column">Patient ID</div>
        <div class="text-column">Name</div>
        <div class="text-column">Type</div>
        <div class="text-column">Codes</div>
        <div class="cancel">Cancel</div>
        <div class="no-show">No Show</div>
      </div>

      <div v-if="state.renderApts">
        <div v-for="(apt) in props.clinic" :key="apt">
          <div v-if="!apt.isCancelled" @click="openAppointment(apt)"
            :class="{ noShow: apt.noShow, cancelled: apt.isCancelled, billed: apt.billed }"
            class="clinic-entry">
            <div class="text-column">{{ apt.time }}</div>
            <div class="text-column">{{ apt.cr }}</div>
            <div class="text-column">{{ apt.name }}</div>
            <div class="text-column">{{ returnAptType(apt.aptType) }}</div>
            <div class="text-column">{{ convertToStringWithCommas(apt.codes) }}</div>
            <!-- X-button -->
            <div class="cancel">
              <button class="danger x-button button" title="Cancel Appointment" @click.stop="cancelApt(apt)">
                <i class="fa-solid fa-x"></i>
              </button>
            </div>
            <div class="no-show">
              <button class="danger x-button " title="Cancel Appointment" @click.stop="noShow(apt)">
                <i class="fa-regular fa-user-large-slash"></i>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- WRAPPER CLASS CLSING DIV -->
  </div>
</template>
<style scoped lang="scss">
.wrapper-class {
  display: flex;
  flex-direction: column;
  width: 1200px;

}

.noShow {
  display: none;
}

.table-header,
.clinic-entry {
  display: flex;
  justify-content: space-between; // Ensures even spacing between columns
}

.table-header {
  text-transform: uppercase;
  color: #aaa;
  padding: 15px 0;
  border-bottom: solid 2px #aaa;
  font-size: 85%;
  ;
}

.clinic-entry {
  display: flex;
  border: 1px solid #ccc;
  margin: 0.5rem 0rem;
  padding: 1rem 0;
  border-radius: 5px;
  align-items: center;

  &:hover {
    background-color: #ebe7f1;
    cursor: pointer;
  }
}

.text-column,
.cancel,
.no-show {
  // align-items: center; // Vertically centers the content
  text-align: center; // Ensures the text is centered
  white-space: normal
}

.text-column {
  flex: 5;
}

.cancel,
.no-show {
  flex: 4;
  display: flex;
  justify-content: center;

  button {
    // padding: 0.75rem;
    padding: 1rem;
    width: 0.5rem;
    height: 2rem;
    font-size: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}


.clinic-title {
  background-color: #fff;
  padding: 1.25rem;
  border-radius: 1rem;
  text-align: center;
  margin: 1rem 0;
  border: 1px solid #ccc;
  border-top: 5px solid #673ab7;
}

.complete {
  background-color: #a3ffa38a;
}

.content-box {
  // width: auto;
  text-align: center;

}




.noShow {
  background-color: #ff00007a;
}

.billed {
  background-color: #8ee48f;

  &:hover {
    background-color: #8ee48f83 !important;
    cursor: pointer;
  }
}
</style>